export enum PagePathname {
  dashboard = '/dashboard',
  alleBerater = '/all-agents',
  beraterErstellen = '/create-agent',
  beraterBearbeiten = '/agent/:number',
  // RITA-1547: Bearbeiten-Seite des Entwurfs „Vertrag erstellen“ (nur Super-Admins).
  beraterVertragBearbeiten = '/agent/:number/vertrag-bearbeiten',
  logout = '/logout',

  // Berichte
  berichte = '/berichte',
  karte = '/berichte/map',
  leistungReport = '/berichte/servicesReport',

  // Buchhaltung
  buchhaltung = '/buchhaltung',
  alleBelege = '/buchhaltung/finance',
  belege = '/buchhaltung/receipt-edit/:number',
  belegeErstellen = '/buchhaltung/receipt-create',
  abschluss = '/buchhaltung/montlyAccounting',
  shopifyBelege = '/buchhaltung/import-shop-receipts',

  // Einstellung
  einstellung = '/einstellung',
  buchungskonten = '/einstellung/bookingAccount',
  ränge = '/einstellung/ranks',
  levels = '/einstellung/levels',
  benutzer = '/einstellung/users',
  marken = '/einstellung/branchOffice',
  leistungen = '/einstellung/services',
  steuern = '/einstellung/tax',
  länder = '/einstellung/coutrys',
  vertragsarten = '/einstellung/contractTyps',
  systemdienstleister = '/einstellung/systemdienstleister',
  systemdienstleisterNeu = '/einstellung/systemdienstleister/neu',
  systemdienstleisterBearbeiten = '/einstellung/systemdienstleister/:id',
  briefvorlagen = '/einstellung/vorlagen',
  briefvorlagenNeu = '/einstellung/vorlagen/neu',
  briefvorlagenBearbeiten = '/einstellung/vorlagen/:id',
  vertragsvorlagenNeu = '/einstellung/vorlagen/vertragsvorlagen/neu',
  vertragsvorlagenBearbeiten = '/einstellung/vorlagen/vertragsvorlagen/:id',
  vertragseditorProbe = '/einstellung/vorlagen/vertragsvorlagen/editor-probe',
  adminPanel = '/einstellung/admin-panel',
  handbuch = '/einstellung/handbuch',
  nutzung = '/einstellung/nutzung',
  mcpAdministration = '/einstellung/mcp',

  // Profil
  profil = '/profil',
}
export default PagePathname;
